(function () {
  // First-visit German auto-switch via /localization
  // (localStorage key: wld_de_localization_v1). Runs at DOMContentLoaded via the
  // defer attribute on this script — earlier than the previous window.load handler
  // and off the critical head-parse path.
  (function maybeAutoSwitchGerman() {
    var storageKey = 'wld_de_localization_v1';
    var host = window.location && window.location.hostname ? window.location.hostname.toLowerCase() : '';
    if (host === 'localhost' || host === '127.0.0.1') return;
    var path = window.location && window.location.pathname ? window.location.pathname : '';
    if (path === '/de' || path.indexOf('/de/') === 0) return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (path.indexOf('/checkout') === 0 || path.indexOf('/admin') === 0) return;

    var ua = (navigator.userAgent || '').toLowerCase();
    if (ua.indexOf('bot') !== -1 || ua.indexOf('crawler') !== -1 || ua.indexOf('spider') !== -1) return;

    try {
      if (localStorage.getItem(storageKey)) return;
    } catch (e) {
      return;
    }

    var languages = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    var prefersGerman = false;
    for (var i = 0; i < languages.length; i++) {
      var lang = languages[i] ? String(languages[i]).toLowerCase() : '';
      if (lang === 'de' || lang.indexOf('de-') === 0) {
        prefersGerman = true;
        break;
      }
    }

    try {
      localStorage.setItem(storageKey, prefersGerman ? '1' : '0');
    } catch (e) {}

    if (!prefersGerman) return;

    var form = document.createElement('form');
    form.method = 'POST';
    form.action = '/localization';
    form.style.display = 'none';

    var methodInput = document.createElement('input');
    methodInput.type = 'hidden';
    methodInput.name = '_method';
    methodInput.value = 'PUT';

    var langInput = document.createElement('input');
    langInput.type = 'hidden';
    langInput.name = 'language_code';
    langInput.value = 'de';

    form.appendChild(methodInput);
    form.appendChild(langInput);
    document.documentElement.appendChild(form);
    form.submit();
  })();

  var crispLoaded = false;
  var crispDelayMs = 10000;
  var crispScriptUrl = 'https://client.crisp.chat/l.js';
  var italicFontLoaded = false;
  var italicFontTriggerSelector = [
    '.header__menu-item',
    '.menu-drawer__menu-item',
    '.list-menu__item',
    '.mega-menu__link',
    '.footer a',
    '.localization-form__select',
    '.collection__view-all a',
    '.collection-list-view-all a',
    '.blog__view-all a',
    'a[id^="ViewAll-"]',
    'a[id^="ViewAllButton-"]',
    '.theme-toggle button'
  ].join(', ');
  var loadedLocalScripts = {};
  var crispTimeoutId = null;
  var crispInteractionEvents = ['mousemove', 'touchstart', 'scroll', 'keydown'];

  function removeCrispInteractionListeners() {
    crispInteractionEvents.forEach(function (eventName) {
      document.removeEventListener(eventName, requestCrispLoad, true);
    });
  }

  function removeItalicFontListeners() {
    document.removeEventListener('mouseover', maybeLoadItalicFont, true);
    document.removeEventListener('focusin', maybeLoadItalicFont, true);
    document.removeEventListener('touchstart', maybeLoadItalicFont, true);
  }

  function hasScriptWithSrc(src) {
    if (!src) return false;

    return Array.prototype.some.call(document.scripts, function (script) {
      return (script.src || '').indexOf(src) !== -1;
    });
  }

  function loadScriptOnce(src) {
    if (!src || loadedLocalScripts[src]) return;
    loadedLocalScripts[src] = true;

    var existingScript = Array.prototype.find.call(document.scripts, function (script) {
      return script.getAttribute('data-optional-src') === src || script.src === src;
    });
    if (existingScript) return;

    var script = document.createElement('script');
    script.src = src;
    script.async = true;
    script.setAttribute('data-optional-src', src);
    document.head.appendChild(script);
  }

  function scheduleLowPriority(callback, timeout) {
    if (typeof callback !== 'function') return;

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(callback, { timeout: timeout || 4000 });
      return;
    }

    setTimeout(callback, timeout || 4000);
  }

  function bindPredictiveSearchLoader(scriptUrl) {
    var predictiveSearchSelector = 'predictive-search, [data-predictive-search-trigger]';
    if (!scriptUrl || !document.querySelector(predictiveSearchSelector)) return;

    var activated = false;
    var activate = function () {
      if (activated) return;
      activated = true;
      document.removeEventListener('focusin', onFocus);
      document.removeEventListener('pointerdown', onPointerDown, true);
      loadScriptOnce(scriptUrl);
    };

    var onFocus = function (event) {
      if (event.target && event.target.closest(predictiveSearchSelector)) {
        activate();
      }
    };

    var onPointerDown = function (event) {
      if (event.target && event.target.closest(predictiveSearchSelector)) {
        activate();
      }
    };

    document.addEventListener('focusin', onFocus);
    document.addEventListener('pointerdown', onPointerDown, { capture: true, passive: true });
    setTimeout(activate, 6000);
  }

  function bindIntersectionLoader(scriptUrl, selectors, options) {
    if (!scriptUrl) return;

    var config = options || {};
    var targets = Array.prototype.slice.call(document.querySelectorAll(selectors));
    if (!targets.length) return;

    var activated = false;
    var observer = null;

    var activate = function () {
      if (activated) return;
      activated = true;
      if (observer) observer.disconnect();
      loadScriptOnce(scriptUrl);
    };

    if (config.interactionSelector) {
      var onInteraction = function (event) {
        if (event.target && event.target.closest(config.interactionSelector)) {
          document.removeEventListener('pointerdown', onInteraction, true);
          if (config.listenTouch) {
            document.removeEventListener('touchstart', onInteraction, true);
          }
          activate();
        }
      };

      document.addEventListener('pointerdown', onInteraction, { capture: true, passive: true });
      if (config.listenTouch) {
        document.addEventListener('touchstart', onInteraction, { capture: true, passive: true });
      }
    }

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(
        function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            activate();
          }
        },
        { rootMargin: config.rootMargin || '250px 0px' }
      );

      targets.forEach(function (target) {
        observer.observe(target);
      });
    } else {
      setTimeout(activate, config.timeout || 3500);
      return;
    }

    scheduleLowPriority(activate, config.timeout || 5000);
  }

  function loadCrisp() {
    if (crispLoaded) return;
    crispLoaded = true;
    removeCrispInteractionListeners();
    if (crispTimeoutId) {
      window.clearTimeout(crispTimeoutId);
      crispTimeoutId = null;
    }

    window.__waldCrispLoadRequested = true;
    window.$crisp = window.$crisp || [];
    window.CRISP_WEBSITE_ID = '1c6aaa76-8cbf-44b3-8e25-ec52becd7d92';

    if (window.__waldCrispPendingVisibility === 'hide') {
      window.$crisp.push(['do', 'chat:hide']);
    }
    delete window.__waldCrispPendingVisibility;

    if (hasScriptWithSrc(crispScriptUrl)) return;

    var script = document.createElement('script');
    script.src = crispScriptUrl;
    script.async = true;
    document.head.appendChild(script);
  }

  function requestCrispLoad() {
    loadCrisp();
  }

  function loadItalicFont() {
    if (italicFontLoaded) return;
    italicFontLoaded = true;
    removeItalicFontListeners();

    if (!document.fonts || typeof document.fonts.load !== 'function') {
      document.documentElement.classList.add('italic-font-loaded');
      return;
    }

    document.fonts.load('italic 400 1em Archivo').then(function () {
      document.documentElement.classList.add('italic-font-loaded');
    });
  }

  function maybeLoadItalicFont(event) {
    if (!event.target || !event.target.closest(italicFontTriggerSelector)) return;
    loadItalicFont();
  }

  crispTimeoutId = window.setTimeout(loadCrisp, crispDelayMs);

  crispInteractionEvents.forEach(function (eventName) {
    document.addEventListener(eventName, requestCrispLoad, {
      capture: true,
      passive: true,
    });
  });

  document.addEventListener('mouseover', maybeLoadItalicFont, {
    capture: true,
    passive: true,
  });
  document.addEventListener('focusin', maybeLoadItalicFont, { capture: true });
  document.addEventListener('touchstart', maybeLoadItalicFont, {
    capture: true,
    passive: true,
  });

  scheduleLowPriority(function () {
    var assets = (window.themeVariables && window.themeVariables.assets) || {};
    bindPredictiveSearchLoader(assets.predictiveSearch);
    bindIntersectionLoader(assets.cardCarousel, '[data-card-carousel], product-recommendations', {
      interactionSelector: '[data-card-carousel]',
      rootMargin: '350px 0px',
      timeout: 4500,
    });
    bindIntersectionLoader(assets.mobileHover, '.card-mood__inner--interactive, .card-mood__inner--video', {
      interactionSelector: '.card-mood__inner--interactive, .card-mood__inner--video',
      rootMargin: '200px 0px',
      timeout: 5000,
      listenTouch: true,
    });
  }, 2500);
})();
